<div
  *ngIf="!initializationTransitionComplete"
  class="vh-100 vw-100 position-fixed top-0 start-0 d-flex align-items-center justify-content-center cxp-transition cxp-splash-page"
  [ngClass]="{ 'cxp-fade-out': !(isInitializing$ | async) }"
>
  <div class="text-center">
    <h1 class="mb-6 text-color-primary-base fw-light">One moment please...</h1>
    <p class="fw-light">Connecting securely to your account</p>
  </div>
</div>

<div
  class="client-requests-grid-container cxp-transition cxp-height-transition"
  [ngClass]="{
    'cxp-no-row-gap h-100 overflow-visible': layoutService.applyTransitionClasses$ | async,
  }"
>
  <section
    awnScrollShadows="vertical"
    class="client-requests-sidebar gap-0 justify-self-end align-items-end"
    [ngClass]="{ 'cxp-layout-full': isFullLayout$ | async }"
    [dataSelector]="dataSelector + 'filters-sidebar'"
  >
    <button
      *ngIf="isFullLayout$ | async"
      andButton
      color="ghost"
      style="height: 34px;"
      class="w-fit-content cxp-transition"
      [ngClass]="{ 'cxp-shrink-height cxp-fade-out': layoutService.applyInverseTransitionClasses$ | async }"
      [attr.aria-hidden]="layoutService.applyInverseTransitionClasses$ | async"
      [dataSelector]="dataSelector + '-back-button'"
      (click)="onGoBack($event)"
    >
      <aiwyn-icon name="arrow-left" [height]="16" [width]="16" class="me-2"></aiwyn-icon>
      Back
    </button>

    <app-client-request-filters
      class="cxp-transition"
      [ngClass]="{ 'cxp-no-row-gap cxp-fade-out cxp-shrink-height overflow-hidden': layoutService.applyTransitionClasses$ | async }"
      [attr.aria-hidden]="layoutService.applyTransitionClasses$ | async"
      [dataSelector]="dataSelector + '-filters-section'"
    ></app-client-request-filters>
  </section>

  <section>
    <app-client-request-groups-container
      class="cxp-transition"
      [ngClass]="{ 'cxp-no-row-gap': layoutService.applyTransitionClasses$ | async }"
      [dataSelector]="dataSelector + '-groups-container'"
    ></app-client-request-groups-container>
  </section>

  <section
    class="client-requests-sidebar justify-self-start"
    [ngClass]="{ 'cxp-layout-full': isFullLayout$ | async }"
    [dataSelector]="dataSelector + '-services-sidebar'"
  >
    <app-client-request-services
      *ngIf="(showUpsell$ | async)"
      class="cxp-transition cxp-height-transition mb-12"
      [ngClass]="{ 'cxp-shrink-height cxp-fade-out': layoutService.applyTransitionClasses$ | async }"
      [attr.aria-hidden]="layoutService.applyTransitionClasses$ | async"
      [dataSelector]="dataSelector + '-services-section'"
    ></app-client-request-services>

    <app-client-request-staff [dataSelector]="dataSelector + '-staff-section'"></app-client-request-staff>
    <app-avatar
      *ngIf="isClientRequestGroupSelected$ | async"
      [avatarInput]="avatars$ | async"
      [domain]="'contact'"
      [limit]="3"
      [showLabel]="true"
      class="mt-12 mb-15"
      [dataSelector]="dataSelector + '-avatars-section'"
    ></app-avatar>
  </section>

  <div *ngIf="isFullLayout$ | async"></div>

  <app-client-portal-footer
    class="mt-4 cxp-transition cxp-height-transition"
    [ngClass]="{ 'cxp-shrink-height cxp-fade-out': layoutService.applyTransitionClasses$ | async }"
    [attr.aria-hidden]="layoutService.applyTransitionClasses$ | async"
    [dataSelector]="dataSelector + '-footer'"
  ></app-client-portal-footer>

  <div *ngIf="isFullLayout$ | async"></div>
</div>

<mat-drawer-container class="vw-100 vh-100 position-fixed top-0 start-0">
  <mat-drawer
    [opened]="isClientRequestSelected$ | async"
    position="end"
    mode="over"
    [disableClose]="true"
    (closed)="onClientRequestDetailsClosed()"
    [ngClass]="(isFullLayout$ | async) ? 'vw-100-show-icon panel-shadow-left' : 'vw-100'"
    [dataSelector]="dataSelector + '-details-drawer'"
  >
    <app-client-request-details
      *ngIf="isClientRequestDetailsOpen$ | async"
      [dataSelector]="dataSelector + '-details-content'"
    ></app-client-request-details>
  </mat-drawer>
</mat-drawer-container>
